<template>
  <v-row justify="start" class="changePassword" data-qa="changepassword-row-ksxg8">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <ForceLogout v-if="showForceLogout" />
    <v-layout wrap class="ml-2 changePassword--gradientBGposition" data-qa="changepassword-layout-cttel">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="changepassword-flex-ywgezv">
        <v-container class="px-12 pt-6" data-qa="changepassword-container-fzyump">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="changepassword-flex-ggk23g">
            <v-row no-gutters justify="center" data-qa="changepassword-row-gptmyn">
              <v-layout row wrap class="pb-2" data-qa="changepassword-layout-lls9qi">
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="changepassword-flex-8bohcf">
                  <v-row no-gutters data-qa="changepassword-row-rbecxf">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("settings.changePassword.title") }}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm10
      md10
      lg10
      xl10
      class="pl-10 changePassword--overlayCardFlex"
     data-qa="changepassword-flex-zka3la">
      <v-layout row wrap class="changePassword--content-padding" data-qa="changepassword-layout-cuoqa">
        <v-flex xs12 sm11 md12 lg10 xl10 class="pt-4" data-qa="changepassword-flex-0rt5l">
      <v-card tile data-qa="changepassword-card-83rjju">
        <v-card-text class="px-2" data-qa="changepassword-card-text-vs7nqm">
          <v-layout wrap data-qa="changepassword-layout-5pqx2c">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="changepassword-flex-dxqdg7">
              <v-form v-model="formValid" class="pa-4 pr-0" data-qa="changepassword-form-cglxti">
                <v-layout justify="center" wrap data-qa="changepassword-layout-dv3ys">
                  <v-flex xs11 sm11 md6 lg6 xl6 data-qa="changepassword-flex-q4o5tf">
                    <v-text-field
                      v-model="oldPassword"
                      @click:append="showOldPasswordVal = !showOldPasswordVal"
                      :color="primaryColor"
                      :label="$t('settings.changePassword.oldPasswordLabel')"
                      :prepend-inner-icon="'mdi-lock-outline'"
                      :type="showOldPasswordVal ? 'text' : 'password'"
                      :rules="resetError ? [rules.required] : []"
                      :maxlength="
                        $appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength
                      "
                      filled
                      background-color="#f0eff7"
                      class="textFieldHighlighter"
                      data-qa="oldPassword"
                      onCopy="return false"
                      onpaste="return false"
                      :append-icon="oldPassword ? showOldPasswordVal ? 'mdi-eye' : 'mdi-eye-off' : ''"
                    />
                    <!-- TODO
                    :append-icon="
                      oldPassword
                        ? showOldPasswordVal
                          ? 'mdi-eye'
                          : 'mdi-eye-off'
                        : ''
                    " -->
                  </v-flex>
                </v-layout>

                <v-layout wrap data-qa="changepassword-layout-baxrdi">
                  <v-flex xs11 sm11 md6 lg6 xl6 data-qa="changepassword-flex-b9fafr">
                    <v-text-field
                      v-model="newPassword"
                      @input="publishUpdatedPassword"
                      @click:append="showNewPasswordVal = !showNewPasswordVal"
                      :color="primaryColor"
                      :label="$t('settings.changePassword.newPasswordLabel')"
                      :prepend-inner-icon="'mdi-lock-outline'"
                      :type="showNewPasswordVal ? 'text' : 'password'"
                      :rules="
                        resetError ? [rules.required, rules.password, rules.minlength] : []
                      "
                      :maxlength="
                        $appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength
                      "
                      :error="
                        resetError
                          ? newPassword && oldPassword === newPassword
                          : false
                      "
                      :error-messages="
                        resetError
                          ? newPassword && oldPassword === newPassword
                            ? $t('settings.changePassword.sameOldNewPassword')
                            : ''
                          : ''
                      "
                      filled
                      background-color="#f0eff7"
                      class="textFieldHighlighter"
                      onCopy="return false"
                      onpaste="return false"
                      data-qa="newPassword"
                      :append-icon="newPassword ? showNewPasswordVal ? 'mdi-eye' : 'mdi-eye-off' : ''"
                    />
                    <!-- TODO
                    :append-icon="
                      newPassword
                        ? showNewPasswordVal
                          ? 'mdi-eye'
                          : 'mdi-eye-off'
                        : ''
                    " -->
                  </v-flex>
                  <v-flex xs12 sm12 md7 lg7 xl7 data-qa="changepassword-flex-dj6sc">
                    <v-row justify="center" data-qa="changepassword-row-y4huhc">
                      <v-col class="pt-0" data-qa="changepassword-col-sr3or">
                        <PasswordPolicyChecker :config="'PASSWORD_POLICY'" />
                      </v-col>
                    </v-row>
                  </v-flex>
                </v-layout>

                <v-layout v-if="newPassword" justify="center" wrap data-qa="changepassword-layout-5chfb">
                  <v-flex xs11 sm11 md6 lg6 xl6 data-qa="changepassword-flex-qjzjql">
                    <v-text-field
                      v-model="renewPassword"
                      @input="publishUpdatedPassword"
                      @click:append="
                        showRenewPasswordVal = !showRenewPasswordVal
                      "
                      :error="
                        resetError && renewPassword
                          ? renewPassword && newPassword !== renewPassword
                          : false
                      "
                      :error-messages="
                        resetError && renewPassword
                          ? renewPassword && newPassword !== renewPassword
                            ? $t('settings.changePassword.passwordMismatch')
                            : ''
                          : ''
                      "
                      :color="primaryColor"
                      :label="$t('settings.changePassword.renewPasswordLabel')"
                      :prepend-inner-icon="'mdi-lock-outline'"
                      :type="showRenewPasswordVal ? 'text' : 'password'"
                      :rules="
                        resetError ? [rules.required, rules.password, rules.minlength] : []
                      "
                      :maxlength="
                        $appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength
                      "
                      filled
                      background-color="#f0eff7"
                      class="textFieldHighlighter"
                      onCopy="return false"
                      onpaste="return false"
                      data-qa="renewPassword"
                      :append-icon="renewPassword ? showRenewPasswordVal ? 'mdi-eye' : 'mdi-eye-off' : ''"
                    />
                    <!-- TODO
                    :append-icon="
                      renewPassword
                        ? showRenewPasswordVal
                          ? 'mdi-eye'
                          : 'mdi-eye-off'
                        : ''
                    " -->
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
          <v-card-actions class="px-5" data-qa="changepassword-card-actions-i3ocv">
            <!-- <v-spacer data-qa="changepassword-spacer-0ctuc"></v-spacer> -->
            <v-btn
              @click="onSave"
              :color="primaryColor"
              :disabled="resetError ? !formValid || !isPasswordValid : true"
              data-qa="savePassword"
              class="text-capitalize white--text py-2 px-4"
              >{{ $t("settings.changePassword.saveButton") }}</v-btn
            >
          </v-card-actions>
        </v-card-text>

        <!-- OTP Section -->
        <Modal
          v-if="enableOTP && showOTPScreen"
          :config="modalConfig.otp"
          @cancel="onOtpModalClose"
        >
          <span slot="modalContent" data-qa="changepassword-span-523qil">
            <OtpInput :otpConfig="otpSettings" />
          </span>
        </Modal>
      </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-row>
</template>

<script>
import event from '@/util/event'
import store from '@/core/store'
import preload from '@/util/preload'
import policies from '@/../mocks/passwordPolicies.json'
import OtpInput from '@/components/common/OtpInput.vue'
import CommonService from '@/service/commonService.js'
import '@/styles/pages/changePassword.scss'

export default {
  name: 'ChangePassword',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    PasswordPolicyChecker: () =>
      import('@/components/DOB-Login/ResetPassword/PasswordPolicyChecker.vue'),
    ForceLogout: () => import('@/views/settings/ForceLogout.vue')
  },
  data () {
    return {
      policies,
      oldPassword: '',
      newPassword: '',
      renewPassword: '',
      to: null,
      formValid: false,
      isPristine: false,
      isLeavingRoute: false,
      refresh: true,
      resetError: false,
      isResetComplete: false,
      showOTPScreen: false,
      showForceLogout: false,
      showOldPasswordVal: false,
      showNewPasswordVal: false,
      showRenewPasswordVal: false,
      enableOTP: this.$appSettings.defaultConfigurations
        .enableOTPForResetPassword,
      otpSettings: {
        resetPasswordTime: 6000,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      passwordRules: [],
      passwordRegEx: '',
      isPasswordValid: false,
      isLogout: false,
      rules: {
        required: (value) => !!value || 'Required.',
        password: (value) => {
          const pattern = new RegExp(this.passwordRegEx)
          return (
            pattern.test(value) ||
            this.$t('settings.changePassword.passwordPatternError')
          )
        },
        minlength: (value) => value.length >= this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength || this.$t('registerUser.loginIdMinLength', { minLen: this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength }),
      }
    }
  },
  created () {
    this.setPasswordRules()
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.enableOTP && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.resetPassword()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (arg) => {
      this.modalConfig.otp.enableSave = true
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    event.$on('POLICY_CHECK', (arg) => {
      this.isPasswordValid = !arg?.disableNext
    })
  },
  mounted () {
    this.resetScreen()
  },
  methods: {
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.showOTPScreen = false
    },
    setPasswordRules () {
      const regEx = store.getters['profileStore/profileData'].passwordRegEx
      this.passwordRegEx = regEx
      if (!this.passwordRegEx) {
        this.getPasswordRules()
      }
    },
    getPasswordRules () {
      if (this.$appSettings.authConfigurations.enableB2C) {
        preload.getPasswordComplexity()
        setTimeout(() => {
          const regEx = this.$store.getters['profileStore/profileData']
            .passwordRegEx
          if (regEx) {
            this.passwordRegEx = regEx
          }
        }, 200)
      } else {
        this.passwordRegEx = this.policies.regex
      }
    },
    publishUpdatedPassword () {
      this.resetError = true
      event.$emit('PASSWORD_UPDATE', {
        new: this.newPassword,
        renew: this.renewPassword
      })
    },
    onSave () {
      if (this.formValid) {
        if (this.enableOTP) {
          this.showOTPScreen = true
          this.modalConfig.otp.enabled = true
          setTimeout(() => {
            event.$emit('SEND_OTP', true)
          }, 200)
        } else {
          // call ResetPassword API - w/o OTP
          this.resetPassword()
        }
      }
    },
    async resetPassword () {
      this.onOtpModalClose()
      if (this.$appSettings.authConfigurations.enableB2C) {
        const passwordPayload = {
          authenticationMethod: 'LOGINID_PASSWORD',
          channelMode: 'WEB',
          newPassword: this.newPassword,
          oldPassword: this.oldPassword,
          userLoginId: sessionStorage.getItem('userId')
            ? JSON.parse(sessionStorage.getItem('userId'))
            : JSON.parse(sessionStorage.getItem('username'))
        }
        const saveStatus = await CommonService.resetPassword(passwordPayload)
        if (saveStatus && saveStatus.message === 'Success') {
          sessionStorage.setItem('isPasswordChanged', true)
          this.isResetComplete = true
          this.showResetSuccessMsg()
        } else {
          if (!(saveStatus && saveStatus.causes && saveStatus.causes[0] && saveStatus.causes[0].code && saveStatus.causes[0].code === 'FEUS-000071')) {
            this.showResetFailureMsg()
          }
        }
      } else {
        sessionStorage.setItem('isPasswordChanged', true)
        this.isResetComplete = true
        this.showResetSuccessMsg()
      }
    },
    resetScreen () {
      this.newPassword = ''
      this.oldPassword = ''
      this.renewPassword = ''
      this.resetError = false
      this.formValid = false
      this.isPasswordValid = false
      this.showOldPasswordVal = false
      this.showNewPasswordVal = false
      this.showRenewPasswordVal = false
      event.$emit('resetPasswordPolicies')
    },
    showResetSuccessMsg () {
      this.showForceLogout = true
    },
    showResetFailureMsg () {
      store.dispatch('appStore/setAppData', {
        message: {
          title: this.$t('settings.changePassword.errorModalTitle'),
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          saveCallback: this.resetScreen,
          content: this.$t('settings.changePassword.resetPasswordFailure'),
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.resetScreen()
      this.isLeavingRoute = false
      this.$router.push(this.to)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.isPristine = !this.formValid
    if (this.isPristine && !this.isResetComplete) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  }
}
</script>

<style>
.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #694ed6 !important;
  border-style: solid;
  border-width: 0.5px;
}
</style>
